import PropTypes from "prop-types";
import React, { useState } from "react";
import { getAboutus, getCompany } from "../../Services/API/Get";
import LoadingSpinner from "../LoadingSpinner/loadingSpinner";

const SectionTitleWithText = ({ spaceTopClass, spaceBottomClass }) => {

  const [company, setcompany] = useState("");
  const [about, setabout] = useState("");
  const [lopen, setlopen] = useState(false);

  const CompanyGet = () => {
    setlopen(true);
    getCompany()
      .then((res) => {
        setlopen(false);
        console.log(res.data);
        setcompany(res.data[res.data.length - 1]);
        // setLogo(res.data[res.data.length - 1].image)
        // this.setState({
        //   logo: res.data[res.data.length - 1].image,
        // });
      })
      .catch((error) => {
        setlopen(false);
        console.error(error);
      });
  };

  const AboutGet = () => {
    setlopen(true);
    getAboutus()
      .then((res) => {
        setlopen(false);
        console.log("about>>", res.data);
        setabout(res.data[res.data.length - 1]);
        // setLogo(res.data[res.data.length - 1].image)
        // this.setState({
        //   logo: res.data[res.data.length - 1].image,
        // });
      })
      .catch((error) => {
        setlopen(false);
        console.error(error);
      });
  };

  React.useEffect(() => {
    CompanyGet();
    AboutGet();

  }, []);

  return (
    <>
      <LoadingSpinner open={lopen} />
      <div
        className={`welcome-area ${spaceTopClass ? spaceTopClass : ""} ${spaceBottomClass ? spaceBottomClass : ""
          }`}
      >


        <div className="welcome-content text-left">
          <div className="container">
            <div className="row">
              <div className="welcome-content text-left">
                {/* <h5>Who Are We</h5> */}
                <h1>{`VACUUM CLEANER SERVICE AND REPAIRS`}</h1>
              </div>

              <div className="row">
                <div className="col-lg-9 col-md-9">
                  <p>
                    With a dedicated team of service technicians who will go always go the extra mile for our customers.
                    We are Melbourne’s leading vacuum repair specialists.
                  </p>
                  <p>
                    Wherever you are located in Melbourne, we offer affordable service repair options that ensures
                    that your commercial vacuum continues to operate optimally.
                  </p>
                  <p>

                    With quick repair turnaround times, our service technicians will bring your vacuum working like new in no time!
                    We 100 percent guarantee you’ll be delighted with us. With a strong reputation for outstanding customer service, we take great pride in our service work.
                  </p>


                </div>
                <div className="col-lg-3 col-md-3">

                  <div
                    className={`single-banner`}
                  >


                    <img src={process.env.PUBLIC_URL + "/assets/img/services/img-3.jpg"} alt="" />


                  </div>


                </div>


              </div>




            </div>


          </div>

          <div className="container">
            <div className="row">
              <div className="welcome-content text-left">
                {/* <h5>Who Are We</h5> */}
                <h1>{`The Vacuum Repair Experts`}</h1>
              </div>

              <div className="row">
                <div className="col-lg-9 col-md-9">
                  <p>
                    Vacuum cleaners for repair are only handled by our senior team of qualified service technicians who have extensive hands-on experience in repairing
                    all brands of industrial vacuums. We carry many common spare parts in stock to repair most makes and models of commercial vacuum cleaners. We support brands including Tennant, Nilfisk, Pullman and Pacvac.
                  </p>
                  <p>
                    Our process starts by comprehensively assessing the condition of your vacuum and the repair required, providing a FREE QUOTE. Once our quote is approved we will proceed, as we carry motors, filters and most spare parts
                    that we need in our warehouse. You’ll then have your vacuum cleaner back in no time!
                  </p>
                  <p>

                    Our qualified team never compromise on machine performance. We only use new and original parts, aiming to match each manufacturer’s specifications.
                  </p>
                  <p>

                    We offer a 90 day back to base warranty on (motor) repairs to ensure that you have complete peace of mind; inclusive of all parts and workmanship.
                  </p>


                </div>
                <div className="col-lg-3 col-md-3">

                  <div
                    className={`single-banner`}
                  >


                    <img src={process.env.PUBLIC_URL + "/assets/img/services/img-4.jpg"} style={{ width: "270px", height: "200px" }} alt="" />


                  </div>


                </div>


              </div>




            </div>


          </div>

        </div>


      </div>
    </>
  );
};

SectionTitleWithText.propTypes = {
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default SectionTitleWithText;
